import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LayoutContainer from '@/components/LayoutContainer';
import pageNotFoundImg from '@/assets/web/404.webp';

import styles from './styles.module.less';

const PageNotFound = () => {
  const navigate = useNavigate();

  const isWideScreen = window.innerWidth > 800;

  const handleRedirect = () => {
    navigate('/');
  };

  const { t } = useTranslation(['resource']);

  return (
    <LayoutContainer>
      <div className={isWideScreen ? styles.horizontalLayout : styles.verticalLayout}>
        <img src={pageNotFoundImg} alt='notfound' />
        <div className={styles.titleWrapper}>
          <div dir='auto'>{t('OOPS!')}</div>
          <div dir='auto'>{t('We can not find your page')}</div>
          <Button
            onClick={() => handleRedirect()}
            className={styles.btn}
            size='large'
            shape='round'
          >
            {t('Return to Homepage')}
          </Button>
        </div>
      </div>
    </LayoutContainer>
  );
};

export default PageNotFound;
